import request from '@/utils/request'


export function wxPay(){
   return request({
       url:'/webapi/authority/pay/wxPay',
       method:'GET'
       
   })
}

export function getOpenId(){
    return request({
        url:'/webapi/authority/pay/getOpenId',
        method:'GET'
        
    })
 }

export function payCode(){
    return request({
        url:`/webapi/wxlogin/getCode`,
        method:'GET'        
    })
 }
 
 // 发送消息
 export function sendMessage(data){
     return request({
         url:'/webapi/authority/pay/paying',
         method:'POST',
         data:data
     })
 }